<template>
    <div id="Login">
        <div class="LoginIcon">
            <img src="../assets/LogoIcon.svg" />
        </div>
        <div class="LoginWelcome">
            <p class="mb-0">大學光學數位整合平台<br>EYE DIGITAL 2.0</p>
            <hr />
            <p class="LoginSmallWelcome">客戶關係管理‧101會員管理 ‧話務整合服務 ‧ <br>電子商務管理‧網站內容管理</p>
        </div>
        <div id="my-video">
            <video playsinline autoplay muted loop width="100%" height="100%" playbackspeed="0.1">
                <source :src='require("@/assets/LoginVideo.mp4")' type='video/mp4'>
            </video>
        </div>
        <form class="form-signin" v-on:submit.prevent="login">
            <p class="title">登入工作台</p>
            <div class="input-box">
                <transition name="fade">
                    <div class="alert-area position-absolute" v-if="AlertText">
                        <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-exclamation-triangle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M7.938 2.016a.146.146 0 0 0-.054.057L1.027 13.74a.176.176 0 0 0-.002.183c.016.03.037.05.054.06.015.01.034.017.066.017h13.713a.12.12 0 0 0 .066-.017.163.163 0 0 0 .055-.06.176.176 0 0 0-.003-.183L8.12 2.073a.146.146 0 0 0-.054-.057A.13.13 0 0 0 8.002 2a.13.13 0 0 0-.064.016zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                            <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                        </svg>
                        <span style="color: #93959C;padding-left: 10px;">{{AlertText}}</span>
                    </div>
                </transition>
                <div class="input-group">
                    <div class="d-flex label justify-content-between">
                        <div>EIP帳號</div>
                        <transition name="fade">
                            <div class="alert-text" v-if="isShowAccountAlert">請輸入帳號</div>
                        </transition>
                    </div>
                    <input type="text" name="AccountID" v-model="AccountID"  @focus="isShowAccountAlert = false,AlertText= ''" />
                </div>
                <div class="input-group">
                    <div class="d-flex label justify-content-between">
                        <div>密碼</div>
                        <transition name="fade">
                            <div class="alert-text" v-if="isShowPasswordAlert">請輸入密碼</div>
                        </transition>
                    </div>
                    <input type="password" name="Password" v-model="Password"  @focus="isShowPasswordAlert = false,AlertText= ''" autocomplete="off" />
                </div>
                <button class="login-btn">登入</button>
            </div>
        </form>
        <transition name="fade">
            <div class="position-fix WelcomeScreen" v-if="loginSuccess">
                <div class="ProfileArea">
                    <div class="ProfilePicture">
                        <img :src="UserInfo.pictureUrl"  @error="imgError(UserInfo)" />
                    </div>
                    <div class="ProfileName">{{UserInfo.fullName}}</div>
                    <div class="ProfileWelecom">歡迎回來</div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
    import 'bootstrap/dist/css/bootstrap.css'
    import 'bootstrap-vue/dist/bootstrap-vue.css'

    // Optionally install plugin
    Vue.use(BootstrapVue)

    const LoginURL= 'Login/GetLoginData'
    export default {
        mounted() {
         
        },
        data() {
            return {
                AccountID: 'admin',
                Password: 'admin',
                isShowAccountAlert:false,
                isShowPasswordAlert: false,
                AlertText: '',
                UserInfo: '',
                loginSuccess: false,
                loginJsonData:{
                    accountID: "108036",
                    deptID: "G611",
                    deptID1: "G",
                    deptName: "數位發展部",
                    deptNameSignList: null,
                    empUserId: "Uf1961d85f3af9912595423d8eb2c9d96",
                    fullName: "洪逸翔",
                    pictureUrl: "../assets/DefaultPic.png",
                    status: 10,
                    titleCaption: "專員",
                    titleID: "263",
                }
            }
        },
        methods: {
            login() {
                let _this = this
                let AccountID = this.AccountID
                let Password = this.Password

                if (!this.AccountID) {
                    this.isShowAccountAlert = true
                } else if (!this.Password) {
                    this.isShowPasswordAlert = true
                }

                if(AccountID == 'admin' && Password == 'admin'){
                    localStorage.setItem("LoginStatus", "true")
                    localStorage.setItem("UserInfo", JSON.stringify(this.loginJsonData))
                    let storage = JSON.parse(localStorage.getItem("UserInfo"));
                    _this.UserInfo = storage
                    _this.loginSuccess = true

                    setTimeout(function () {
                        _this.$router.push({ name: 'Home' });
                    }, 2500)
                } else{
                    _this.AlertText = '帳密錯誤'
                }
            },
            imgError(UserInfo) {
               UserInfo.pictureUrl = require('../assets/DefaultPic.png')
            }
        }
    }
</script>
<style scoped>
   

    .LoginIcon {
        position: fixed;
        top: 50px;
        left: 10%;
        z-index: 999;
        opacity:0.8;
    }

    .ProfileArea {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        color: white;
        text-align: center;
    }
        .ProfileArea div{
            margin-bottom:30px;
        }
        .ProfileArea .ProfilePicture {
            width: 180px;
            height: 180px;
            border: 1px solid #FC8342;
            border-radius: 50%;
            overflow:hidden;
        }
        .ProfileArea .ProfilePicture img {
            width: 100%;
            object-fit: contain;
            padding: 5px;
            border-radius: 50%;
        }

        .ProfileArea .ProfileName {
            font-size: 24px;
            font-weight: bold;
        }
        .ProfileArea .ProfileWelecom {
            font-size: 28px;
            font-weight: bold;
        }
    .WelcomeScreen {
        left:0;
        top:0;
        width: 100%;
        height: 100%;
        background: #1D1E24;
        position: fixed;
        z-index:20;
    }
    #Login {
        position: relative;
        width: 100%;
        height: 100vh;
    }

    #my-video {
        position: fixed;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;
    }

    .alert-text {
        color:#D75858;
    }

    .alert-area {
        background: #d7585845;
        border-radius: 15px;
        padding: 10px 20px;
        font-size: 14px;
        color: white;
        width: 100%;
        top: -85px;
    }

    video {
        position: absolute;
        object-fit: cover;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .form-signin {
        padding: 128px 100px 183px 100px;
        position: absolute;
        width: 600px;
        height: 744px;
        right: 10%;
        top: 50%;
        transform: translateY(-50%);
        background: #1D1E24;
        box-shadow: -10px 0px 25px rgba(0, 0, 0, 0.3);
        border-radius: 20px;
    }
        .form-signin .title {
            font-style: normal;
            font-weight: 500;
            font-size: 28px;
            color: white;
            text-align: center;
        }

        .form-signin .input-box {
            margin-top: 120px;
            color: #B5B7BF;
            position:relative;
        }

        .form-signin .input-group {
            flex-direction: column;
            margin-bottom: 1.5rem;
            font-size: 14px;
            color: #93959C;
        }

        .form-signin .label {
            font-size: 14px;
            margin-bottom: 0.5rem;
        }

        .form-signin input {
            background: transparent;
            border: 1px solid #6c6b6b50;
            border-radius: 15px;
            padding: 5px 15px;
            color: #B5B7BF;
            height: 40px;
        }
            .form-signin input:focus {
                outline: 0px;
                border: 1px solid #0090FF;
                border-radius: 15px;
            }
            .form-signin button:focus {
                outline: none;
            }

        .form-signin .login-btn {
            background: #0090FF;
            box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.5);
            border-radius: 15px;
            width: 100%;
            border: 0px;
            font-size: 15px;
            height: 40px;
            display:flex;
            align-items:center;
            justify-content:center;
            color:white;
            margin-top:60px;
        }

            .form-signin .login-btn:hover {
                background: #32A6FF;
            }

        .form-signin input:-webkit-autofill,
        .form-signin input:-webkit-autofill:hover,
        .form-signin input:-webkit-autofill:focus,
        .form-signin input:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px #1d1e24 inset !important;
            transition: background-color 5000s ease-in-out 0s; /*透明*/
            -webkit-text-fill-color: #B5B7BF !important; /*字體顏色*/
            border: 1px solid #6c6b6b50 !important;
        }
            

            .fade-enter-active,
            .fade-leave-active {
                transition-duration: 0.3s;
                transition-property: opacity;
                transition-timing-function: ease;
            }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

    .LoginWelcome {
        position: absolute;
        opacity:0.8;
        left: 10%;
        top: 50%;
        transform: translateY(-50%);
        color: #D0D2D9;
        mix-blend-mode: luminosity;
        font-size: 48px;
        font-weight: bold;
        z-index: 10;
    }

    .LoginSmallWelcome {
        font-size: 18px;
        font-weight: 100;
    }

    .LoginWelcome hr {
        mix-blend-mode: luminosity;
        border-top: 1.5px solid #D0D2D9;
        background: #D0D2D9;
        margin:30px 0;
    }

    @media screen and (max-width: 1400px) {
       
        .form-signin{
            padding: 40px 100px 40px 100px;
            width: 500px;
            height: 470px;
        }

        .form-signin .input-box {
            margin-top: 65px;
           
        }

        .alert-area{
            top:-58px;
        }

        .LoginWelcome{
            font-size:36px;
        }

    }

    @media screen and (max-width: 990px) {
        .form-signin {
            padding: 30px;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            height: auto;
            right: 0;
            background: #1d1e24;
        }

        .LoginWelcome{
            display:none !important;
        }
    }
 
</style>